import gql from 'graphql-tag';

export const CreatePaymentMutation = gql`
  mutation createPayment($orderNumber: String!, $language: String!, $paymentMethod: String!) {
    createPayment(payment: {
      orderNumber: $orderNumber,
      language: $language,
      paymentMethod: $paymentMethod,
    }) {
      gatewayUrl
      code
      token
      # error // todo: pokud zde uvedu error, na frontendu se to celé zacyklí
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/Query/Payment/CreatePayment.tsx